'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var Q = require('q');  /* jshint ignore:line */
var _ = require('lodash');  /* jshint ignore:line */
var util = require('util');  /* jshint ignore:line */
var DocumentList = require('./service/document').DocumentList;
var Page = require('../../../base/Page');  /* jshint ignore:line */
var SyncListList = require('./service/syncList').SyncListList;
var SyncMapList = require('./service/syncMap').SyncMapList;
var SyncStreamList = require('./service/syncStream').SyncStreamList;
var deserialize = require(
    '../../../base/deserialize');  /* jshint ignore:line */
var serialize = require('../../../base/serialize');  /* jshint ignore:line */
var values = require('../../../base/values');  /* jshint ignore:line */

var ServiceList;
var ServicePage;
var ServiceInstance;
var ServiceContext;

/* jshint ignore:start */
/**
 * Initialize the ServiceList
 *
 * @constructor Twilio.Sync.V1.ServiceList
 *
 * @param {Twilio.Sync.V1} version - Version of the resource
 */
/* jshint ignore:end */
ServiceList = function ServiceList(version) {
  /* jshint ignore:start */
  /**
   * @function services
   * @memberof Twilio.Sync.V1#
   *
   * @param {string} sid - sid of instance
   *
   * @returns {Twilio.Sync.V1.ServiceContext}
   */
  /* jshint ignore:end */
  function ServiceListInstance(sid) {
    return ServiceListInstance.get(sid);
  }

  ServiceListInstance._version = version;
  // Path Solution
  ServiceListInstance._solution = {};
  ServiceListInstance._uri = `/Services`;
  /* jshint ignore:start */
  /**
   * create a ServiceInstance
   *
   * @function create
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.friendlyName] -
   *          A string that you assign to describe the resource
   * @param {string} [opts.webhookUrl] -
   *          The URL we should call when Sync objects are manipulated
   * @param {boolean} [opts.reachabilityWebhooksEnabled] -
   *          Whether the service instance should call webhook_url when client endpoints connect to Sync
   * @param {boolean} [opts.aclEnabled] -
   *          Whether token identities in the Service must be granted access to Sync objects by using the Permissions resource
   * @param {boolean} [opts.reachabilityDebouncingEnabled] -
   *          Whether every endpoint_disconnected event occurs after a configurable delay
   * @param {number} [opts.reachabilityDebouncingWindow] -
   *          The reachability event delay in milliseconds
   * @param {boolean} [opts.webhooksFromRestEnabled] -
   *          Whether the Service instance should call webhook_url when the REST API is used to update Sync objects
   * @param {function} [callback] - Callback to handle processed record
   *
   * @returns {Promise} Resolves to processed ServiceInstance
   */
  /* jshint ignore:end */
  ServiceListInstance.create = function create(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'FriendlyName': _.get(opts, 'friendlyName'),
      'WebhookUrl': _.get(opts, 'webhookUrl'),
      'ReachabilityWebhooksEnabled': serialize.bool(_.get(opts, 'reachabilityWebhooksEnabled')),
      'AclEnabled': serialize.bool(_.get(opts, 'aclEnabled')),
      'ReachabilityDebouncingEnabled': serialize.bool(_.get(opts, 'reachabilityDebouncingEnabled')),
      'ReachabilityDebouncingWindow': _.get(opts, 'reachabilityDebouncingWindow'),
      'WebhooksFromRestEnabled': serialize.bool(_.get(opts, 'webhooksFromRestEnabled'))
    });

    var promise = this._version.create({uri: this._uri, method: 'POST', data: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new ServiceInstance(this._version, payload, this._solution.sid));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Streams ServiceInstance records from the API.
   *
   * This operation lazily loads records as efficiently as possible until the limit
   * is reached.
   *
   * The results are passed into the callback function, so this operation is memory
   * efficient.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function each
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         each() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no pageSize is defined but a limit is defined,
   *         each() will attempt to read the limit with the most efficient
   *         page size, i.e. min(limit, 1000)
   * @param {Function} [opts.callback] -
   *         Function to process each record. If this and a positional
   *         callback are passed, this one will be used
   * @param {Function} [opts.done] -
   *          Function to be called upon completion of streaming
   * @param {Function} [callback] - Function to process each record
   */
  /* jshint ignore:end */
  ServiceListInstance.each = function each(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    if (opts.callback) {
      callback = opts.callback;
    }
    if (_.isUndefined(callback)) {
      throw new Error('Callback function must be provided');
    }

    var done = false;
    var currentPage = 1;
    var currentResource = 0;
    var limits = this._version.readLimits({
      limit: opts.limit,
      pageSize: opts.pageSize
    });

    function onComplete(error) {
      done = true;
      if (_.isFunction(opts.done)) {
        opts.done(error);
      }
    }

    function fetchNextPage(fn) {
      var promise = fn();
      if (_.isUndefined(promise)) {
        onComplete();
        return;
      }

      promise.then(function(page) {
        _.each(page.instances, function(instance) {
          if (done || (!_.isUndefined(opts.limit) && currentResource >= opts.limit)) {
            done = true;
            return false;
          }

          currentResource++;
          callback(instance, onComplete);
        });

        if (!done) {
          currentPage++;
          fetchNextPage(_.bind(page.nextPage, page));
        } else {
          onComplete();
        }
      });

      promise.catch(onComplete);
    }

    fetchNextPage(_.bind(this.page, this, _.merge(opts, limits)));
  };

  /* jshint ignore:start */
  /**
   * Lists ServiceInstance records from the API as a list.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function list
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {object} [opts] - Options for request
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         list() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no page_size is defined but a limit is defined,
   *         list() will attempt to read the limit with the most
   *         efficient page size, i.e. min(limit, 1000)
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  ServiceListInstance.list = function list(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    var deferred = Q.defer();
    var allResources = [];
    opts.callback = function(resource, done) {
      allResources.push(resource);

      if (!_.isUndefined(opts.limit) && allResources.length === opts.limit) {
        done();
      }
    };

    opts.done = function(error) {
      if (_.isUndefined(error)) {
        deferred.resolve(allResources);
      } else {
        deferred.reject(error);
      }
    };

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    this.each(opts);
    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single page of ServiceInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function page
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.pageToken] - PageToken provided by the API
   * @param {number} [opts.pageNumber] -
   *          Page Number, this value is simply for client state
   * @param {number} [opts.pageSize] - Number of records to return, defaults to 50
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  ServiceListInstance.page = function page(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'PageToken': opts.pageToken,
      'Page': opts.pageNumber,
      'PageSize': opts.pageSize
    });

    var promise = this._version.page({uri: this._uri, method: 'GET', params: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new ServicePage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single target page of ServiceInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function getPage
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {string} [targetUrl] - API-generated URL for the requested results page
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  ServiceListInstance.getPage = function getPage(targetUrl, callback) {
    var deferred = Q.defer();

    var promise = this._version._domain.twilio.request({method: 'GET', uri: targetUrl});

    promise = promise.then(function(payload) {
      deferred.resolve(new ServicePage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Constructs a service
   *
   * @function get
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @param {string} sid - The SID of the Service resource to fetch
   *
   * @returns {Twilio.Sync.V1.ServiceContext}
   */
  /* jshint ignore:end */
  ServiceListInstance.get = function get(sid) {
    return new ServiceContext(this._version, sid);
  };

  /* jshint ignore:start */
  /**
   * Provide a user-friendly representation
   *
   * @function toJSON
   * @memberof Twilio.Sync.V1.ServiceList#
   *
   * @returns Object
   */
  /* jshint ignore:end */
  ServiceListInstance.toJSON = function toJSON() {
    return this._solution;
  };

  ServiceListInstance[util.inspect.custom] = function inspect(depth, options) {
    return util.inspect(this.toJSON(), options);
  };

  return ServiceListInstance;
};


/* jshint ignore:start */
/**
 * Initialize the ServicePage
 *
 * @constructor Twilio.Sync.V1.ServicePage
 *
 * @param {V1} version - Version of the resource
 * @param {Response<string>} response - Response from the API
 * @param {ServiceSolution} solution - Path solution
 *
 * @returns ServicePage
 */
/* jshint ignore:end */
ServicePage = function ServicePage(version, response, solution) {
  // Path Solution
  this._solution = solution;

  Page.prototype.constructor.call(this, version, response, this._solution);
};

_.extend(ServicePage.prototype, Page.prototype);
ServicePage.prototype.constructor = ServicePage;

/* jshint ignore:start */
/**
 * Build an instance of ServiceInstance
 *
 * @function getInstance
 * @memberof Twilio.Sync.V1.ServicePage#
 *
 * @param {ServicePayload} payload - Payload response from the API
 *
 * @returns ServiceInstance
 */
/* jshint ignore:end */
ServicePage.prototype.getInstance = function getInstance(payload) {
  return new ServiceInstance(this._version, payload);
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServicePage#
 *
 * @returns Object
 */
/* jshint ignore:end */
ServicePage.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

ServicePage.prototype[util.inspect.custom] = function inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the ServiceContext
 *
 * @constructor Twilio.Sync.V1.ServiceInstance
 *
 * @property {string} sid - The unique string that identifies the resource
 * @property {string} uniqueName -
 *          An application-defined string that uniquely identifies the resource
 * @property {string} accountSid - The SID of the Account that created the resource
 * @property {string} friendlyName -
 *          The string that you assigned to describe the resource
 * @property {Date} dateCreated -
 *          The ISO 8601 date and time in GMT when the resource was created
 * @property {Date} dateUpdated -
 *          The ISO 8601 date and time in GMT when the resource was last updated
 * @property {string} url - The absolute URL of the Service resource
 * @property {string} webhookUrl -
 *          The URL we call when Sync objects are manipulated
 * @property {boolean} webhooksFromRestEnabled -
 *          Whether the Service instance should call webhook_url when the REST API is used to update Sync objects
 * @property {boolean} reachabilityWebhooksEnabled -
 *          Whether the service instance calls webhook_url when client endpoints connect to Sync
 * @property {boolean} aclEnabled -
 *          Whether token identities in the Service must be granted access to Sync objects by using the Permissions resource
 * @property {boolean} reachabilityDebouncingEnabled -
 *          Whether every endpoint_disconnected event occurs after a configurable delay
 * @property {number} reachabilityDebouncingWindow -
 *          The reachability event delay in milliseconds
 * @property {string} links - The URLs of related resources
 *
 * @param {V1} version - Version of the resource
 * @param {ServicePayload} payload - The instance payload
 * @param {sid_like} sid - The SID of the Service resource to fetch
 */
/* jshint ignore:end */
ServiceInstance = function ServiceInstance(version, payload, sid) {
  this._version = version;

  // Marshaled Properties
  this.sid = payload.sid; // jshint ignore:line
  this.uniqueName = payload.unique_name; // jshint ignore:line
  this.accountSid = payload.account_sid; // jshint ignore:line
  this.friendlyName = payload.friendly_name; // jshint ignore:line
  this.dateCreated = deserialize.iso8601DateTime(payload.date_created); // jshint ignore:line
  this.dateUpdated = deserialize.iso8601DateTime(payload.date_updated); // jshint ignore:line
  this.url = payload.url; // jshint ignore:line
  this.webhookUrl = payload.webhook_url; // jshint ignore:line
  this.webhooksFromRestEnabled = payload.webhooks_from_rest_enabled; // jshint ignore:line
  this.reachabilityWebhooksEnabled = payload.reachability_webhooks_enabled; // jshint ignore:line
  this.aclEnabled = payload.acl_enabled; // jshint ignore:line
  this.reachabilityDebouncingEnabled = payload.reachability_debouncing_enabled; // jshint ignore:line
  this.reachabilityDebouncingWindow = deserialize.integer(payload.reachability_debouncing_window); // jshint ignore:line
  this.links = payload.links; // jshint ignore:line

  // Context
  this._context = undefined;
  this._solution = {sid: sid || this.sid, };
};

Object.defineProperty(ServiceInstance.prototype,
  '_proxy', {
    get: function() {
      if (!this._context) {
        this._context = new ServiceContext(this._version, this._solution.sid);
      }

      return this._context;
    }
});

/* jshint ignore:start */
/**
 * fetch a ServiceInstance
 *
 * @function fetch
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceInstance.prototype.fetch = function fetch(callback) {
  return this._proxy.fetch(callback);
};

/* jshint ignore:start */
/**
 * remove a ServiceInstance
 *
 * @function remove
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceInstance.prototype.remove = function remove(callback) {
  return this._proxy.remove(callback);
};

/* jshint ignore:start */
/**
 * update a ServiceInstance
 *
 * @function update
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.webhookUrl] -
 *          The URL we should call when Sync objects are manipulated
 * @param {string} [opts.friendlyName] -
 *          A string that you assign to describe the resource
 * @param {boolean} [opts.reachabilityWebhooksEnabled] -
 *          Whether the service instance should call webhook_url when client endpoints connect to Sync
 * @param {boolean} [opts.aclEnabled] -
 *          Whether token identities in the Service must be granted access to Sync objects by using the Permissions resource
 * @param {boolean} [opts.reachabilityDebouncingEnabled] -
 *          Whether every endpoint_disconnected event occurs after a configurable delay
 * @param {number} [opts.reachabilityDebouncingWindow] -
 *          The reachability event delay in milliseconds
 * @param {boolean} [opts.webhooksFromRestEnabled] -
 *          Whether the Service instance should call webhook_url when the REST API is used to update Sync objects
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceInstance.prototype.update = function update(opts, callback) {
  return this._proxy.update(opts, callback);
};

/* jshint ignore:start */
/**
 * Access the documents
 *
 * @function documents
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.DocumentList}
 */
/* jshint ignore:end */
ServiceInstance.prototype.documents = function documents() {
  return this._proxy.documents;
};

/* jshint ignore:start */
/**
 * Access the syncLists
 *
 * @function syncLists
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.SyncListList}
 */
/* jshint ignore:end */
ServiceInstance.prototype.syncLists = function syncLists() {
  return this._proxy.syncLists;
};

/* jshint ignore:start */
/**
 * Access the syncMaps
 *
 * @function syncMaps
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.SyncMapList}
 */
/* jshint ignore:end */
ServiceInstance.prototype.syncMaps = function syncMaps() {
  return this._proxy.syncMaps;
};

/* jshint ignore:start */
/**
 * Access the syncStreams
 *
 * @function syncStreams
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @returns {Twilio.Sync.V1.ServiceContext.SyncStreamList}
 */
/* jshint ignore:end */
ServiceInstance.prototype.syncStreams = function syncStreams() {
  return this._proxy.syncStreams;
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServiceInstance#
 *
 * @returns Object
 */
/* jshint ignore:end */
ServiceInstance.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

ServiceInstance.prototype[util.inspect.custom] = function inspect(depth,
    options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the ServiceContext
 *
 * @constructor Twilio.Sync.V1.ServiceContext
 *
 * @property {Twilio.Sync.V1.ServiceContext.DocumentList} documents -
 *          documents resource
 * @property {Twilio.Sync.V1.ServiceContext.SyncListList} syncLists -
 *          syncLists resource
 * @property {Twilio.Sync.V1.ServiceContext.SyncMapList} syncMaps -
 *          syncMaps resource
 * @property {Twilio.Sync.V1.ServiceContext.SyncStreamList} syncStreams -
 *          syncStreams resource
 *
 * @param {V1} version - Version of the resource
 * @param {sid_like} sid - The SID of the Service resource to fetch
 */
/* jshint ignore:end */
ServiceContext = function ServiceContext(version, sid) {
  this._version = version;

  // Path Solution
  this._solution = {sid: sid, };
  this._uri = `/Services/${sid}`;

  // Dependents
  this._documents = undefined;
  this._syncLists = undefined;
  this._syncMaps = undefined;
  this._syncStreams = undefined;
};

/* jshint ignore:start */
/**
 * fetch a ServiceInstance
 *
 * @function fetch
 * @memberof Twilio.Sync.V1.ServiceContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceContext.prototype.fetch = function fetch(callback) {
  var deferred = Q.defer();
  var promise = this._version.fetch({uri: this._uri, method: 'GET'});

  promise = promise.then(function(payload) {
    deferred.resolve(new ServiceInstance(this._version, payload, this._solution.sid));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * remove a ServiceInstance
 *
 * @function remove
 * @memberof Twilio.Sync.V1.ServiceContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceContext.prototype.remove = function remove(callback) {
  var deferred = Q.defer();
  var promise = this._version.remove({uri: this._uri, method: 'DELETE'});

  promise = promise.then(function(payload) {
    deferred.resolve(payload);
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * update a ServiceInstance
 *
 * @function update
 * @memberof Twilio.Sync.V1.ServiceContext#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.webhookUrl] -
 *          The URL we should call when Sync objects are manipulated
 * @param {string} [opts.friendlyName] -
 *          A string that you assign to describe the resource
 * @param {boolean} [opts.reachabilityWebhooksEnabled] -
 *          Whether the service instance should call webhook_url when client endpoints connect to Sync
 * @param {boolean} [opts.aclEnabled] -
 *          Whether token identities in the Service must be granted access to Sync objects by using the Permissions resource
 * @param {boolean} [opts.reachabilityDebouncingEnabled] -
 *          Whether every endpoint_disconnected event occurs after a configurable delay
 * @param {number} [opts.reachabilityDebouncingWindow] -
 *          The reachability event delay in milliseconds
 * @param {boolean} [opts.webhooksFromRestEnabled] -
 *          Whether the Service instance should call webhook_url when the REST API is used to update Sync objects
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed ServiceInstance
 */
/* jshint ignore:end */
ServiceContext.prototype.update = function update(opts, callback) {
  if (_.isFunction(opts)) {
    callback = opts;
    opts = {};
  }
  opts = opts || {};

  var deferred = Q.defer();
  var data = values.of({
    'WebhookUrl': _.get(opts, 'webhookUrl'),
    'FriendlyName': _.get(opts, 'friendlyName'),
    'ReachabilityWebhooksEnabled': serialize.bool(_.get(opts, 'reachabilityWebhooksEnabled')),
    'AclEnabled': serialize.bool(_.get(opts, 'aclEnabled')),
    'ReachabilityDebouncingEnabled': serialize.bool(_.get(opts, 'reachabilityDebouncingEnabled')),
    'ReachabilityDebouncingWindow': _.get(opts, 'reachabilityDebouncingWindow'),
    'WebhooksFromRestEnabled': serialize.bool(_.get(opts, 'webhooksFromRestEnabled'))
  });

  var promise = this._version.update({uri: this._uri, method: 'POST', data: data});

  promise = promise.then(function(payload) {
    deferred.resolve(new ServiceInstance(this._version, payload, this._solution.sid));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

Object.defineProperty(ServiceContext.prototype,
  'documents', {
    get: function() {
      if (!this._documents) {
        this._documents = new DocumentList(this._version, this._solution.sid);
      }
      return this._documents;
    }
});

Object.defineProperty(ServiceContext.prototype,
  'syncLists', {
    get: function() {
      if (!this._syncLists) {
        this._syncLists = new SyncListList(this._version, this._solution.sid);
      }
      return this._syncLists;
    }
});

Object.defineProperty(ServiceContext.prototype,
  'syncMaps', {
    get: function() {
      if (!this._syncMaps) {
        this._syncMaps = new SyncMapList(this._version, this._solution.sid);
      }
      return this._syncMaps;
    }
});

Object.defineProperty(ServiceContext.prototype,
  'syncStreams', {
    get: function() {
      if (!this._syncStreams) {
        this._syncStreams = new SyncStreamList(this._version, this._solution.sid);
      }
      return this._syncStreams;
    }
});

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Sync.V1.ServiceContext#
 *
 * @returns Object
 */
/* jshint ignore:end */
ServiceContext.prototype.toJSON = function toJSON() {
  return this._solution;
};

ServiceContext.prototype[util.inspect.custom] = function inspect(depth, options)
    {
  return util.inspect(this.toJSON(), options);
};

module.exports = {
  ServiceList: ServiceList,
  ServicePage: ServicePage,
  ServiceInstance: ServiceInstance,
  ServiceContext: ServiceContext
};
